export const URLs = {
  STOREBRAND_HOME: 'https://storebrand.no',
  MELD_SKADE_PRIVAT: 'https://www.storebrand.no/privat/forsikring/meld-skade',
  MELD_SKADE_BEDRIFT:
    'https://www.storebrand.no/bedrift/vare-tjenester/forsikring/meld-skade-bedrift',
  MELD_SKADE_PRIVAT_HUS_HYTTE_INNBO:
    'https://www.storebrand.no/privat/forsikring/meld-skade/hus-hytte-og-innbo'
};
